import React from 'react';
import useSeo from '../lib/useSeo';
import Navbar from '../components/site/Navbar';
import Hero from '../components/site/Hero';
import Problem from '../components/site/Problem';
import Model from '../components/site/Model';
import Upside from '../components/site/Upside';
import WhyPartners from '../components/site/WhyPartners';
import Roles from '../components/site/Roles';
import Subscriber from '../components/site/Subscriber';
import Quality from '../components/site/Quality';
import EnrichIQ from '../components/site/EnrichIQ';
import Products from '../components/site/Products';
import LeadJourney from '../components/site/LeadJourney';
import IntegrationsMarquee from '../components/site/IntegrationsMarquee';
import CaseStudies from '../components/site/CaseStudies';
import Playbook from '../components/site/Playbook';
import FAQ from '../components/site/FAQ';
import FinalCTA from '../components/site/FinalCTA';
import Footer from '../components/site/Footer';
import { Toaster } from '../components/ui/toaster';

const Landing = () => {
  useSeo({
    title: '5DBS — The Revenue Engine Behind B2B Media Brands',
    description: 'Outsourced, brand-safe lead generation for B2B publishers. We run direct-sold lead-gen programmes under your brand — every lead verified before it reaches your client\'s sales team.',
    path: '/',
  });
  return (
    <div className="min-h-screen bg-white font-sans text-navy">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Model />
        <Upside />
        <Subscriber />
        <WhyPartners />
        <Roles />
        <Quality />
        <LeadJourney />
        <Products />
        <EnrichIQ />
        <IntegrationsMarquee />
        <CaseStudies />
        <Playbook />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default Landing;
